module.exports = __webpack_public_path__ + "static/media/edsiderlogowhite.660ce303.png";